module.exports = __webpack_public_path__ + "img/location.d52cea98.png";